import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { loginStatus, adminStatus } from 'store/slices/accountSlice';

// project imports
import { useEffect } from 'react';

// ==============================|| ADMIN GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AdminGuard = ({ children }) => {
    const isLoggedIn = useSelector(loginStatus);
    const isAdmin = useSelector(adminStatus);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('../login', { replace: true });
        } else if (!isAdmin) {
            navigate('../denied', { replace: true });
        }
    }, [isLoggedIn, isAdmin, navigate]);

    return children;
};

AdminGuard.propTypes = {
    children: PropTypes.node
};

export default AdminGuard;
